import { Grid, IconButton, Tooltip, Typography } from '@mui/material';
import React from 'react';
import MuiIcon from '../../../../shared/styles/mui/helpers/mui-icon.helper';

interface IProps {
  onReload: () => void;
  handleCreateSourceMapClick: () => void;
}

function GrossToNetToolbarComponent({ onReload, handleCreateSourceMapClick }: IProps) {

  return (<Grid paddingX={2} container direction='row' alignItems='center' justifyContent='flex-start'>

    {/* Reload */}
    <Tooltip title='Reload'>
      <IconButton color='secondary' onClick={onReload}>{MuiIcon.RELOAD()}</IconButton>
    </Tooltip>

    {/* Title */}
    <Typography sx={{ flexGrow: 1 }} variant='subtitle2'>Source Map List</Typography>

    {/* Create Report */}
    <Tooltip title='Create SourceMap'>
      <IconButton color='primary' onClick={handleCreateSourceMapClick}>{MuiIcon.ADD_CIRCLE()}</IconButton>
    </Tooltip>

  </Grid>);
}
export default GrossToNetToolbarComponent;